module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/9441359e55050b29ba601580a7e27b0d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_crown.svg
// module id = W5D1
// module chunks = 0